import 'styles/app/App.scss';

export default function App() {
    return <div>The Perfect Date</div>;
}
